import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import API from './api';

let initialized = false;

export async function initPushNotifications(navigate) {
  if (!Capacitor.isNativePlatform()) return;
  if (initialized) return;
  initialized = true;

  const perm = await PushNotifications.checkPermissions();
  let allowed = perm.receive;
  if (allowed !== 'granted') {
    const req = await PushNotifications.requestPermissions();
    allowed = req.receive;
  }
  if (allowed !== 'granted') {
    initialized = false;
    return;
  }

  await PushNotifications.register();

  PushNotifications.addListener('registration', async (token) => {
    try {
      await API.post('/notifications/push-token', {
        token: token.value,
        platform: Capacitor.getPlatform(),
      });
    } catch (err) {
      console.error('[push] envoi token échoué:', err.message);
    }
  });

  PushNotifications.addListener('registrationError', (err) => {
    console.error('[push] erreur enregistrement:', err);
  });

  PushNotifications.addListener('pushNotificationReceived', (notif) => {
    console.log('[push] reçue (foreground):', notif);
  });

  PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    const data = action.notification?.data || {};
    if (navigate && data.route) {
      navigate(data.route);
    }
  });
}

export async function unregisterPushNotifications() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await PushNotifications.removeAllListeners();
  } catch {}
  initialized = false;
}
